import { render, staticRenderFns } from "./addStudentToRoute.vue?vue&type=template&id=3d573290&"
import script from "./addStudentToRoute.vue?vue&type=script&lang=js&"
export * from "./addStudentToRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports